module.exports = __webpack_public_path__ + "static/media/corbata.f31d5460.png";